import { render, staticRenderFns } from "./BindsSelect.vue?vue&type=template&id=106a13d3&"
import script from "./BindsSelect.vue?vue&type=script&lang=js&"
export * from "./BindsSelect.vue?vue&type=script&lang=js&"
import style0 from "./BindsSelect.vue?vue&type=style&index=0&id=106a13d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports